// extracted by mini-css-extract-plugin
module.exports = {"content":"PoliciesPage_content__lKFjF","contentText":"PoliciesPage_contentText__8P_DX"};